
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MemberListItemLoading',
  props: {
    hideBorder: {
      type: Boolean,
      default: false
    }
  }
})
